/**
 * 订单结算与支付
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/order/settlement',
    name: 'settlement',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/order/settlement.vue'
      ),
    meta: {
      title: '结算',
      isCommon: true
    }
  },
  {
    path: '/order/settlement2',
    name: 'settlement2',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/order/popcornSettlement.vue'
      ),
    meta: {
      title: '结算',
      isCommon: true
    }
  },
  {
    path: '/order/pay',
    // 原来与 /order/settlement 同名 settlement（按 name 跳转会命中前一条）
    name: 'orderPay',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/order/pay.vue'
      ),
    meta: {
      title: '支付',
      isCommon: true
    }
  }
];
